<div #cropbox class="cropper-box" [style.height.px]="height">
    <div *ngIf="_cropperSettings && _cropperSettings.canvasWidth !== 0">
        <img-cropper #cropper  uppDataid="cropper-image" [image]="_croppedImage" [settings]="_cropperSettings" (onCrop)="OnCrop($event)"></img-cropper>
    </div>
</div>
<ion-button uppDataid="cropper-submit" size="large" expand="block" color="primary" (click)="OnSave()">
    {{tr('@crop_accept_changes')}}
</ion-button>  